import React, { useEffect, useState } from 'react'
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import HomeBanner from '../components/HomePage/homeBanner'
import StartNewsLetter from '../components/HomePage/StartNewsLetter'
import StartAssociationsSection from '../components/HomePage/StartAssociationsSection'
import StartWhyMemberSection from '../components/HomePage/StartWhyMemberSection'
import BoostSection from '../components/HomePage/BoostSection'
import SimplePricingSection from '../components/HomePage/SimplePricingSection'
import LetsDiscuss from '../components/HomePage/LetsDiscuss'
import StartTestimonialSection from '../components/HomePage/StartTestimonialSection'
import FaqSection from '../components/HomePage/FaqSection'
import WhatAreSnapVideo from '../components/HomePage/WhatAreSnapVideo'
// import '../components/HomePage/css/styles.css';
// import '../assets/css/responsive.css';
import '../components/HomePage/css/animate.min.css';
import '../components/HomePage/css/owl.carousel.min.css';
import '../components/HomePage/css/jquery.fancybox.css';
import { KeyboardArrowUp } from '@mui/icons-material';

function HomePage() {
    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;            
            const rootElement = document.getElementById("root");

            if (rootElement) {
                if (scrollY >= 70) {
                    rootElement.classList.add("sticky");
                } else {
                    rootElement.classList.remove("sticky");
                }
            }

            if (scrollY > 100) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <>
            <div id="wrapper">

                <Header />

                <main>
                    
                    <HomeBanner />
                    
                    <WhatAreSnapVideo />
                    
                    <StartNewsLetter />
                    
                    <StartAssociationsSection />
                    
                    <StartWhyMemberSection />

                    <StartTestimonialSection />
                    
                    <BoostSection />

                    <FaqSection />
                    
                    <SimplePricingSection />
                    
                    <LetsDiscuss />

                </main>

                <Footer />

            </div>
            <a onClick={scrollToTop} id="myBtn" style={{ display: showScroll ? "flex" : "none", justifyContent: 'center', alignItems: 'center' }}><KeyboardArrowUp fontSize="large" /></a>
        </>
    )
}

export default HomePage